import { useEffect, useState } from "react";

export function useFakeProgress(error: boolean, initialIncrease: number = 0.1) {
	const [progress, setProgress] = useState(0);

	useEffect(() => {
		if (error) {
			return undefined;
		}
		let currentProgress = 0;
		let increase = initialIncrease;

		const interval = setInterval(() => {
			setProgress((prevProgress) => {
				if (prevProgress < 1) {
					currentProgress += increase;
					const percentage = Math.round((Math.atan(currentProgress) / (Math.PI / 2)) * 1000) / 1000;

					if (percentage >= 0.99) {
						clearInterval(interval);
						return 0.99; // Set the final progress to 99 before complete
					}

					if (percentage >= 0.7) {
						increase = 0.001;
					}

					return percentage;
				}
				clearInterval(interval);
				return prevProgress;
			});
		}, 100);
		return () => clearInterval(interval);
	}, [error, initialIncrease]);

	return progress;
}
